import { makeStyles } from "@material-ui/core/styles";
const UseStyles = makeStyles((theme) => ({
  main_grid: {
    backgroundColor: "#F5F5F5",
  },
  box_design: {
    // border: "3px solid rgba(224, 224, 224, 1)",
    padding: "0.25rem 0.75rem",
    background: "#F5F5F5",
    fontSize: "0.75rem !important",
  },
  fundedDealText: {
    fontSize: "1.0rem !important",
    fontWeight: "bold",
    padding: "0.25rem 0.75rem",
    color: "#2d2d2d",
    border: "none !important",
  },
  grid_space: {
    // margin: "0.5rem",
    boxShadow: "0px 2px 7px 1px rgb(224 224 224)",
    padding: "0.5rem",
    // color: "black",
  },
  headGrid_space: {
    padding: "0.25rem",
  },
  headerText: {
    fontSize: "1.1rem !important",
    padding: "0.25rem 0.75rem",
    color: "#2d2d2d",
    fontWeight:"bold"
  },
  containerShadow: {
    backgroundColor: "#F9F9F3",
    color: "#2d2d2d",
    boxShadow: "0 0 10px 1px rgb(224 224 224)",
    padding: "0.3rem",
  },
  applicantHead: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  headerTextApplicant: {
    fontSize: "1.1rem !important",
    padding: "0.25rem 0.75rem",
    marginTop: "8px",
    color: "#2d2d2d",
    fontWeight:"bold"
  },
  applicantIcon: {
    fontSize: "1.0rem !important",
    borderRadius: "5px",
    padding: "3px",
  },
}));

export default UseStyles;
